export default "__VITE_ASSET__wscTQJOy__"